export const reactQueryClientOptions = {
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      cacheTime: 300000, // FIVE_MINUTE_IN_MILLI
      retry: 3,
    },
  },
};
